import script from "./FileDropZone.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileDropZone.vue?vue&type=script&lang=ts&setup=true"

import "./FileDropZone.vue?vue&type=style&index=0&id=99a58a60&lang=css"

const __exports__ = script;

export default __exports__